export var FibreProviderTypes;
(function (FibreProviderTypes) {
    FibreProviderTypes[FibreProviderTypes["NA"] = 0] = "NA";
    FibreProviderTypes[FibreProviderTypes["nbn\u00AE"] = 1] = "nbn\u00AE";
    FibreProviderTypes[FibreProviderTypes["Opticomm"] = 2] = "Opticomm";
    FibreProviderTypes[FibreProviderTypes["Fujitsu"] = 3] = "Fujitsu";
    FibreProviderTypes[FibreProviderTypes["RedTrain"] = 4] = "RedTrain";
    FibreProviderTypes[FibreProviderTypes["Telstra"] = 5] = "Telstra";
})(FibreProviderTypes || (FibreProviderTypes = {}));
export var SlabFibreServiceType;
(function (SlabFibreServiceType) {
    SlabFibreServiceType[SlabFibreServiceType["NA"] = 0] = "NA";
    SlabFibreServiceType[SlabFibreServiceType["FTTH"] = 1] = "FTTH";
    SlabFibreServiceType[SlabFibreServiceType["WIRELESS"] = 2] = "WIRELESS";
    SlabFibreServiceType[SlabFibreServiceType["SATELLITE"] = 3] = "SATELLITE";
    SlabFibreServiceType[SlabFibreServiceType["FTTN"] = 4] = "FTTN";
    SlabFibreServiceType[SlabFibreServiceType["FTTB"] = 5] = "FTTB";
    SlabFibreServiceType[SlabFibreServiceType["HFC"] = 6] = "HFC";
    SlabFibreServiceType[SlabFibreServiceType["FTTC"] = 7] = "FTTC";
})(SlabFibreServiceType || (SlabFibreServiceType = {}));
export var OptionServiceType;
(function (OptionServiceType) {
    OptionServiceType[OptionServiceType["NA"] = 0] = "NA";
    OptionServiceType[OptionServiceType["FTTH"] = 1] = "FTTH";
    OptionServiceType[OptionServiceType["FTTB"] = 2] = "FTTB";
    OptionServiceType[OptionServiceType["FTTN"] = 3] = "FTTN";
    OptionServiceType[OptionServiceType["WIRELESS"] = 4] = "WIRELESS";
    OptionServiceType[OptionServiceType["HFC"] = 5] = "HFC";
    OptionServiceType[OptionServiceType["VILLAWOOD"] = 6] = "VILLAWOOD";
    OptionServiceType[OptionServiceType["FTTC"] = 7] = "FTTC";
})(OptionServiceType || (OptionServiceType = {}));
export const OptionServiceTypeDisplay = {
    FTTH: 'Fibre To The Premises (FTTP)',
    FTTN: 'Fibre To The Node (FTTN)',
    FTTB: 'Fibre To The Building (FTTB)',
    FTTC: 'Fibre To The Curb (FTTC)',
    HFC: 'Hybrid Fibre Coaxial (HFC)',
    WIRELESS: 'Fixed Wireless (FW)',
    NA: 'NA',
};
export const TechnologyTypes = Object.freeze({
    NBN: 'NBN',
    FIBRE: 'Fibre',
});
export var OnePlatformOptionServiceTypeEnum;
(function (OnePlatformOptionServiceTypeEnum) {
    OnePlatformOptionServiceTypeEnum["NA"] = "NA";
    OnePlatformOptionServiceTypeEnum["FTTH"] = "Fibre To The Premises";
    OnePlatformOptionServiceTypeEnum["FTTB"] = "Fibre To The Building";
    OnePlatformOptionServiceTypeEnum["FTTN"] = "Fibre To The Node";
    OnePlatformOptionServiceTypeEnum["WIRELESS"] = "Wireless";
    OnePlatformOptionServiceTypeEnum["HFC"] = "Hybrid Fibre Coaxial";
    OnePlatformOptionServiceTypeEnum["FTTC"] = "Fibre To The Curb";
})(OnePlatformOptionServiceTypeEnum || (OnePlatformOptionServiceTypeEnum = {}));
export var OnePlatformForecastAccessTechnologyEnum;
(function (OnePlatformForecastAccessTechnologyEnum) {
    OnePlatformForecastAccessTechnologyEnum["FIBRE"] = "Fibre";
})(OnePlatformForecastAccessTechnologyEnum || (OnePlatformForecastAccessTechnologyEnum = {}));
export var ActiveServiceCodes;
(function (ActiveServiceCodes) {
    ActiveServiceCodes["SFDC"] = "ActiveServiceSFDC";
    ActiveServiceCodes["ASOP"] = "activeServiceOnePlatform";
    ActiveServiceCodes["AOOP"] = "activeOrderOnePlatform";
    ActiveServiceCodes["TLIP"] = "activeServiceTulip";
})(ActiveServiceCodes || (ActiveServiceCodes = {}));
